var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacDocumentOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.8,
    height: 19.8,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 0H4.6875C2.10938 0 0 2.0925 0 4.65V26.35C0 28.9075 2.10938 31 4.6875 31H17.4531C18.7031 31 19.8906 30.5195 20.7656 29.636L23.625 26.7995C24.5156 25.9315 25 24.7535 25 23.5135V4.65C25 2.0925 22.8906 0 20.3125 0ZM14.0625 23.25H7.8125C6.95312 23.25 6.25 22.5525 6.25 21.7C6.25 20.8475 6.95312 20.15 7.8125 20.15H14.0625C14.9219 20.15 15.625 20.8475 15.625 21.7C15.625 22.5525 14.9219 23.25 14.0625 23.25ZM17.1875 17.05H7.8125C6.95312 17.05 6.25 16.3525 6.25 15.5C6.25 14.6475 6.95312 13.95 7.8125 13.95H17.1875C18.0469 13.95 18.75 14.6475 18.75 15.5C18.75 16.3525 18.0469 17.05 17.1875 17.05ZM17.1875 10.85H7.8125C6.95312 10.85 6.25 10.1525 6.25 9.3C6.25 8.4475 6.95312 7.75 7.8125 7.75H17.1875C18.0469 7.75 18.75 8.4475 18.75 9.3C18.75 10.1525 18.0469 10.85 17.1875 10.85Z",
    fill: "#EA5D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacDocumentOrange);
export default __webpack_public_path__ + "static/media/contac_document_orange.109a8e9c9970af6c993c6cd26ce4b2f4.svg";
export { ForwardRef as ReactComponent };